"use strict";
/**
 * Created on 03 26 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * Serialization/deserialization of {@link SelloutProductPriceImpact}.
 *
 * @author JMe
 */


var SelloutProductPriceImpactConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutProductPriceImpactConverter, _DataObjectConverter_);

  function SelloutProductPriceImpactConverter() {
    _classCallCheck(this, SelloutProductPriceImpactConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutProductPriceImpactConverter).apply(this, arguments));
  }

  return SelloutProductPriceImpactConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutProductPriceImpactConverter = SelloutProductPriceImpactConverter;